import axios from "axios";
import {
  PERMISSION_REQUEST,
  PERMISSION_SUCCESS,
  PERMISSION_FAIL,
  PERMISSION_CLEAR_ERRORS,
} from "../Constants/permissions_constants";

export const getPermission = (company) => async (dispatch) => {
  try {
    dispatch({
      type: PERMISSION_REQUEST,
    });
    const permission = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/permissions/?`,
      {
        params: { company_name: company === null ? "" : company },
      }
    );

    dispatch({
      type: PERMISSION_SUCCESS,
      payload: permission,
    });
  } catch (error) {
    dispatch({
      type: PERMISSION_FAIL,
      payload: error.response,
    });
  }
};

export const addNewPermission = (permission_payload) => async (dispatch) => {
  try {
    dispatch({
      type: PERMISSION_REQUEST,
    });
    await axios.post(
      `${process.env.REACT_APP_API_URL}/api/permissions/`,
      permission_payload
    );
    const permission = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/permissions/`
    );
    dispatch({
      type: PERMISSION_SUCCESS,
      payload: permission,
    });
  } catch (error) {
    dispatch({
      type: PERMISSION_FAIL,
      payload: error.response,
    });
  }
};

export const updatePermission = (permission_payload, company) => async (dispatch) => {
  try {
    dispatch({
      type: PERMISSION_REQUEST,
    });
    await axios.patch(
      `${process.env.REACT_APP_API_URL}/api/permission-on-user-id/`,
      permission_payload
    );

    const permission = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/permissions/?`,
      {
        params: { company_name: company === null ? "" : company },
      }

    );
    dispatch({
      type: PERMISSION_SUCCESS,
      payload: permission,
    });
  } catch (error) {
    dispatch({
      type: PERMISSION_FAIL,
      payload: error.response,
    });
  }
};

export const deletePermission = (id) => async (dispatch) => {
  try {
    dispatch({
      type: PERMISSION_REQUEST,
    });
    await axios.delete(
      `${process.env.REACT_APP_API_URL}/api/permissions/${id}/`
    );
    const permission = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/permissions/`
    );
    dispatch({
      type: PERMISSION_SUCCESS,
      payload: permission,
    });
  } catch (error) {
    dispatch({
      type: PERMISSION_FAIL,
      payload: error.response,
    });
  }
};
export const permission_clearErrors = () => async (dispatch) => {
  dispatch({
    type: PERMISSION_CLEAR_ERRORS,
  });
};
